import { SET_SALES_ADDRESS } from 'actions';
import { IAddress } from 'typings';

export function setServiceAddress(address: IAddress) {
  return { address, type: SET_SALES_ADDRESS };
}
